module.exports = __webpack_public_path__ + "static/img/no-data.06c3964.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/no-data.png
// module id = XXq2
// module chunks = 4